module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/LhEOnK/tc-custom/9780544087279.jpg?1705491569060",
      "alt": "This image is the cover for the book Last Bogler, How to Catch a Bogle"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Last Bogler, How to Catch a Bogle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The hunt is on for child-eating monsters in Victorian England in the “wonderfully crafted fantasy series” ("), _c('i', [_vm._v("School Library Journal")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" With the plague of bogles in Victorian London barely contained, bogle hunter Alfred Bunce needs all the help he can get. So Ned Roach becomes a bogler’s apprentice, luring child-eating monsters from their lairs just like his friends Jem and Birdie. It’s dangerous work that takes Ned into mysterious and hidden parts of the city."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" But times in London are changing. As the machine age emerges, the very existence of bogles is questioned, and the future of bogling is in jeopardy. And the stakes get even higher for the team of boglers when an old enemy appears—a threat that may be deadlier than any bogle…"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “[A] richly atmospheric adventure trilogy.”—"), _c('i', [_vm._v("Booklist")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Catherine Jinks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Catherine Jinks grew up in Papua New Guinea and now resides in New South Wales, Australia. She is a three-time winner of the Children's Book Council of Australia Book of the Year award and has received the Centenary Medal for her contribution to Australian children's literature. Her popular works for young readers include the Evil Genius series, The Reformed Vampire Support Group, and the trilogy that began with How to Catch a Bogle. Visit her website at www.catherinejinks.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (www.hmhco.com)\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0